import { _404 } from './handlers';
import { IConfiguredHttp } from './http';

export interface IPropertyLegacyIdLookupResponse {
	id: number;
	legacy_property_id: string | null;
}

export interface ILegacyLookupApi {
	lookUpLegacyId: (id: number) => Promise<IPropertyLegacyIdLookupResponse>;
}

const legacyLookupFactory = (http: IConfiguredHttp, prefix = ''): ILegacyLookupApi => ({
	lookUpLegacyId(id) {
		return http.get(`${prefix}/property/${id}/legacyId`).catch(_404({}));
	},
});

export default legacyLookupFactory;
